import { MIN_TOUCH_TARGET_PX } from './layoutConstants';

/** Shared glass treatment for floating pills (the mobile title tucks underneath). */
const glassPillCss = {
  backdropFilter: 'blur(18px) saturate(1.4)',
  WebkitBackdropFilter: 'blur(18px) saturate(1.4)',
};

/** Glass surface shared by multi-control pills and single circular chips. */
export const glassSurfaceProps = {
  borderWidth: 'hairline' as const,
  borderColor: 'border' as const,
  bg: 'bg/50' as const,
  boxShadow: 'xs' as const,
  flexShrink: 0,
  position: 'relative' as const,
  zIndex: 2,
  css: glassPillCss,
};

/**
 * Single circular glass control — equal box + one border (no pill padding wrapping
 * a second circle, which reads as an oval). Same chip as the mobile back button.
 */
export const glassCircleProps = {
  ...glassSurfaceProps,
  borderRadius: 'full' as const,
  w: `${MIN_TOUCH_TARGET_PX}px`,
  h: `${MIN_TOUCH_TARGET_PX}px`,
  minW: `${MIN_TOUCH_TARGET_PX}px`,
  minH: `${MIN_TOUCH_TARGET_PX}px`,
  p: 0,
  px: 0,
};

/** Hover for a glass circle sitting on art or a dimmed page. */
export const glassCircleHoverProps = {
  bg: 'bgElevated',
  borderColor: 'textMuted',
  color: 'text',
} as const;
